import SnSummaryCard from "./snSummaryCard.container";

export default SnSummaryCard;
